module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../node_modules/ts-loader/index.js!./clinic-upload.ts"));
	}, "clinic-interface");
}